import { cn } from '@shared/shared-utils';

type Properties = {
  number: number;
  className?: string;
};

const StepNumber = ({ number, className }: Properties) => {
  return (
    <div
      className={cn(
        'bg-ogn-blue text-white w-[50px] h-[50px] flex items-center justify-center shrink-0 text-[40px] rounded-sm font-bold',
        className,
      )}
    >
      {number}
    </div>
  );
};

export { StepNumber };
